module.exports = __webpack_public_path__ + "static/media/bg11.dc2caba9.png";